module.exports = __webpack_public_path__ + "img/ie.55e63505.svg";